import type { AssetListParams, AuditFilters, FeedbackListParams, IdeaFilterParams, IdeaListParams, Period, RunGroupParams, RunListParams } from '../types';

export const queryKeys = {
  session: ['session'] as const,
  version: ['version'] as const,
  providers: ['auth', 'providers'] as const,
  users: ['users'] as const,
  permissionMatrix: ['access', 'permissions'] as const,
  settings: ['settings'] as const,
  hostings: ['ai', 'hostings'] as const,
  models: ['ai', 'models'] as const,
  processes: ['ai', 'processes'] as const,
  budget: ['ai', 'budget'] as const,
  usage: (period: Period) => ['ai', 'usage', period] as const,
  runs: (params: RunListParams) => ['ai', 'runs', params] as const,
  runGroups: (params: RunGroupParams) => ['ai', 'run-groups', params] as const,
  audit: (filters: AuditFilters, cursor: string | null, limit: number) =>
    ['audit', 'list', filters, cursor, limit] as const,
  auditSummary: (filters: AuditFilters) => ['audit', 'summary', filters] as const,
  auditEntry: (id: string) => ['audit', 'entry', id] as const,
  auditFacets: ['audit', 'facets'] as const,
  auditTracing: ['audit', 'tracing'] as const,
  ideaCatalogue: ['ideas', 'catalogue'] as const,
  dimensions: ['ideas', 'dimensions'] as const,
  ideas: (params: IdeaListParams) => ['ideas', 'list', params] as const,
  ideaPoints: (filters: IdeaFilterParams) => ['ideas', 'points', filters] as const,
  idea: (id: string) => ['ideas', 'detail', id] as const,
  ideaRun: (id: string, runId: string) => ['ideas', 'run', id, runId] as const,
  industries: ['industries'] as const,
  partners: ['partners'] as const,
  countries: ['countries'] as const,
  userLookup: (q: string) => ['users', 'lookup', q] as const,
  assets: (params: AssetListParams) => ['assets', 'list', params] as const,
  asset: (id: string) => ['assets', 'detail', id] as const,
  assetHistory: (id: string, page: number, pageSize: number) => ['assets', 'history', id, page, pageSize] as const,
  assetTemplate: (kind: string) => ['assets', 'template', kind] as const,
  catalogCard: ['dashboard', 'catalog'] as const,
  promptVersions: ['business-opportunities', 'prompt-versions'] as const,
  matrix: ['business-opportunities', 'matrix'] as const,
  promptVersion: (version: number) => ['business-opportunities', 'prompt-versions', version] as const,
  dashboard: ['dashboard'] as const,
  feedbackList: (params: FeedbackListParams) => ['feedback', 'list', params] as const,
  feedback: (id: string) => ['feedback', 'detail', id] as const,
  mcpTokens: ['mcp', 'tokens'] as const,
  apiKeys: ['api-keys'] as const,
  integrationOpenapi: ['integration', 'openapi'] as const,
  mcpConsent: (request: string) => ['mcp', 'consent', request] as const,
  processPrompt: (key: string) => ['ai', 'processes', key, 'prompt'] as const,
};

/** Refresh every 5 s while research is queued or running, then stop. */
export const PENDING_POLL_MS = 5000;
